<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <CellForm :station-id="stationId" :table-url="tableUrl"></CellForm>
    </div>
  </div>
</template>

<script setup>
import TheHeader from "@/components/layouts/TheHeader.vue";
import CellForm from "@/components/cell/CellForm.vue";
import { onMounted } from "vue";

const stationId = 58;
const viewName = "Cell";
const tableUrl = `/Material/GetLastMaterialCells?num=15`;

onMounted(() => {
  document.title = viewName;
});
</script>
